<script setup>
import { onMounted, onUnmounted } from 'vue';

defineProps({
  isOpen: { type: Boolean, default: false },
  title: { type: String, default: '' }
});
const emit = defineEmits(['close']);

function handleKeydown(event) {
  if (event.key === 'Escape') {
    emit('close');
  }
}

onMounted(() => {
  document.addEventListener('keydown', handleKeydown);
});

onUnmounted(() => {
  document.removeEventListener('keydown', handleKeydown);
});
</script>
<template>
  <div v-if="isOpen" class="modal">
    <div class="modal-header">
      <h3>{{ title }}</h3>
      <button @click="$emit('close')" class="modal-close">&times;</button>
    </div>
    <div class="modal-body">
      <slot></slot>
    </div>
  </div>
</template>
